<script>
export default {
    props: {
        elements: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<template>
    <div class="pb-1">
        <div v-for="el in elements">{{ el.title }}</div>
    </div>
</template>
